export function buildQueryExtension(config) {
    return {
        toQuerySyntax() {
            const { name, parameters } = config;
            const argumentExpression = buildParameters(parameters);
            return `$${name}(${argumentExpression})`;
        },
    };
}
function buildParameters(params) {
    return Object.entries(params)
        .map((entry) => {
        const [name, value] = entry;
        const formatted = typeof value === 'string' ? value : value.toQuerySyntax();
        return `${name}: ${formatted}`;
    })
        .join(', ');
}
